import React from 'react'
import { HOME_TOPIC_ONE } from '../../global/assets/Icons';
import HOME_TOPIC_FOUR from "../../global/assets/png/Topic-Four.png"
import AtomicButton from '../../atomic/button/AtomicButton';
import { isMobile } from '../../global/ScreenSizeHelper';

const TopicFour = () => {

    if (isMobile) {
        return (
            <>
                Mobile Topic Four
            </>
        )

    }



    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'row',
            backgroundColor: '#fce76b',
            width: '100%',
            height: '600px',
        }}>

            <div style={{
                width: '600px',
                padding: '110px 0px 0px 20px',
                flexWrap: 'wrap',
                // border: '1px solid red' 
            }}>
                <div style={{
                    color: '#1B1642',
                    fontSize: '40px',
                    // fontFamily: "Playfair Display",
                    fontFamily: 'Inter Medium',
                    lineHeight: '45px',
                    // fontWeight: 600,
                    flexWrap: 'wrap',
                }}>Earn while you sleep when you invite friends and family</div>
                <div style={{
                    fontFamily: 'Inter Regular', color: '#1B1642',
                    fontSize: '25px', marginTop: '20px'
                }}>A conversation with Libor Michalek, President of Affirm about how they pioneered a new type of lending.</div>

                <AtomicButton
                    label="Get started"
                    handleSubmit={() => { console.log('---clicked') }}
                    style={{
                        width: '325px',
                        backgroundColor: '#B8ECD7',
                        color: '#083643',
                        marginTop: '50px'

                    }}
                    loading={false}
                    disabled={false}
                />
            </div>
            <div style={{
                width: '600px',
                marginLeft: '2px',
                // border: '1px solid black', 
                padding: '80px 0px 0px 20px'
            }}>
                <img alt="" src={HOME_TOPIC_FOUR} width={550} style={{ marginBottom: '33px' }} ></img>
            </div>
        </div>
    )

}

export default TopicFour